import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CreateGeoSingleMethodRequestPayload } from '@/models/ps-management/ps-management.model';

export default class CreateGeoSingleMethodRequest extends ApiResourceMethod<{}> {
  public perform(payload: CreateGeoSingleMethodRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${payload.countryCode}`,
        data: payload.payloadData,
      },
      (payload: BaseResponse<{}>) => ({
        data: payload.data,
      }),
    );
  }
}
